import { FileContent } from '../state/project/types';

export const convertBinaryArrayToBlob = (file: FileContent) => {
  const binaryString = window.atob(file.fileContents);
  const bytes = new Uint8Array(binaryString.length);
  const mappedData = bytes.map((byte, i) => binaryString.charCodeAt(i));
  const blob = new Blob([mappedData], { type: file.contentType });
  return blob;
};
